import { Swiper } from 'swiper';
import { Navigation, Pagination, EffectCreative, Scrollbar} from 'swiper/modules';

new Swiper('.image-slider-paysage', {
  modules: [Navigation, Pagination],

  loop: false,
  slidesPerView: 1,
  slideToClickedSlide: true,
  centeredSlides: true,

  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

new Swiper('.map-navigation', {

  loop: false,
  slidesPerView: 'auto',
  freeMode: true,
  spaceBetween: 12,
});

document.querySelectorAll('.image-slider-brands-listing').forEach((el) => {
  new Swiper(el as HTMLElement, {
    modules: [Navigation, Pagination],

    loop: false,
    slidesPerView: 1,
    slideToClickedSlide: true,
    centeredSlides: true,
    spaceBetween: 12,

    pagination: {
      el: el.querySelector('.swiper-pagination'),
      type: 'fraction',
    },

    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
  });
});

document.querySelectorAll('.image-slider-vineyards-listing').forEach((el) => {
  new Swiper(el as HTMLElement, {
    modules: [Navigation, Pagination],

    loop: false,
    slidesPerView: 1,
    slideToClickedSlide: true,
    centeredSlides: true,
    spaceBetween: 12,

    pagination: {
      el: el.querySelector('.swiper-pagination'),
      type: 'fraction',
    },

    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
  });
});

new Swiper('.partners-slider', {
  modules: [Scrollbar],

  loop: false,
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 12,

  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

new Swiper('.mosaic-mobile-slider', {
  modules: [Navigation],

  loop: false,
  slidesPerView: 'auto',
  slideToClickedSlide: true,
  centeredSlides: true,
  spaceBetween: 8,

  navigation: {
    nextEl: '.mosaic-button-next',
    prevEl: '.mosaic-button-prev',
  },
});

new Swiper('.houses-slider', {
  modules: [Navigation, EffectCreative],
  loop: false,
  slidesPerView: 1,
  centeredSlides: false,
  effect: 'creative',
  navigation: {
    nextEl: '.houses-slider-next',
    prevEl: '.houses-slider-prev',
  },
  creativeEffect: {
    limitProgress: 4,
    prev: {
      translate: [0, 0, -400],
      opacity: 0,
      scale: 0.2,
    },
    next: {
      translate: ['105%', 0, 0],
    },
  },
  breakpoints: {
    1200: {
      creativeEffect: {
        limitProgress: 4,
        next: { translate: ['calc(100% + 24px)', 0, 0] },
      },
    },
  },
});

new Swiper('.brands-slider', {
  modules: [Navigation],

  loop: false,
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 8,

  navigation: {
    nextEl: '.slider-brands-next-mobile',
    prevEl: '.slider-brands-prev-mobile',
  },

  breakpoints: {
    1300: {
      centeredSlides: false,
      slidesPerView: 1.8,
      navigation: {
        nextEl: '.slider-brands-next',
        prevEl: '.slider-brands-prev',
      },
    },
  },
});